module.exports = __webpack_public_path__ + "media/brands/yamaha-15e8e6b5.png";